import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgBusyModule } from 'ng-busy';
import { TranslateModule } from '@ngx-translate/core';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { MobilePageHeaderComponent } from './components/mobile-page-header/mobile-page-header.component';
import { ScrollableContentComponent } from './components/scrollable-content/scrollable-content.component';
import { UiRoundedPanelComponent } from './components/ui-rounded-panel/ui-rounded-panel.component';
import { UiMobileSingleCounterComponent } from './components/ui-mobile-single-counter/ui-mobile-single-counter.component';
import { MobileMenuItemComponent } from './components/mobile-menu-item/mobile-menu-item.component';
import { FormsModule } from '@angular/forms';

const COMPONENTS = [
  MobileMenuComponent,
  MobilePageHeaderComponent,
  ScrollableContentComponent,
  UiRoundedPanelComponent,
  UiMobileSingleCounterComponent,
  MobileMenuItemComponent,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgCakeItEasyUtilsModule,
    NgBusyModule,
    TranslateModule,
    FormsModule,
  ],
  declarations: [
    ...COMPONENTS,
  ],
  exports: [
    ...COMPONENTS
  ]
})
export class MobileUiModule {
}
